import React from "react";
import { Button } from "@components/buttons";

export default function UploadedFilesPreview({
	files,
	removeFile,
}: {
	files: File[];
	removeFile(id: number): void;
}) {
	return (
		<>
			{files.map((file, idx) => {
				const fileTypeAbrv = file.type.split("/")[1];

				return (
					<div
						key={file.name + idx}
						className="chat--support__attachment"
					>
						<a
							href={URL.createObjectURL(file)}
							target="_blank"
							className="card--file__body chat--support__attachment__body"
						>
							<i
								className={
									"u-icon u-icon--xlrg u-icon--file u-icon--file--" +
									fileTypeAbrv
								}
							/>
							<div className="card--file__info u-display--f--grow">
								<div className="card--file__name chat--support__attachment__name">
									{file.name}
								</div>
								<div className="card--file__size u-type--left">
									{(file.size / 1024).toFixed(2) + " KB"}
								</div>
							</div>
						</a>

						<Button
							type="button"
							className="btn--square btn--square--sml btn--ghost"
							iconOnly
							iconClassName="u-icon--sml u-icon--close"
							onClick={() => {
								removeFile(idx);
							}}
						/>
					</div>
				);
			})}
		</>
	);
}
